import { combineReducers } from 'redux';
import { reducer as base } from './base';
import { reducer as existingIntegrations } from './existingIntegrations';
import { reducer as availableIntegrations } from './availableIntegrations';
import { reducer as integrationForm } from './integrationForm';


export default combineReducers({
  base,
  existingIntegrations,
  availableIntegrations,
  integrationForm,
});
